import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ClienteComboOutput, ClienteOperacaoOutput } from 'src/app/@shared/models/consulta-detalhe';
import { BaseCrudService, montarQueryString } from '../base-crud/base-crud.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class DownloadArquivoService extends BaseCrudService {
  
    /*
      Informar a rota do Controller correspondente na API
      */
    apiController = "Download";
  
    /*
    URLS principais
    */
    consultarUrl = (input: any) => `ConsultaFiliaisCNPJ?${montarQueryString(input)}`;
    excelUrl = (input: any) => `downloadArquivo?${montarQueryString(input)}`;
    atualizarUrl = (input: any) => `Atualizar`;
    cadastrarUrl = (input: any) => `Inserir`;
  
    constructor(public override http: HttpClient) {
      super(http);
    }

  
  public getClientesAtivos(): Observable<ClienteComboOutput[]> {
    return this.http.get<ClienteComboOutput[]>(`Download/GetClienteDownload`)
  }

  public getOperacao(clienteId: any): Observable<ClienteOperacaoOutput[]> {
    return this.http.get<ClienteOperacaoOutput[]>(`Download/GetOperacaoDownload?clienteId=${clienteId}`)
  }

  // public pesquisarArquivos(input: { ipServidor: string; diretorio: string }) {
  //   return this.http.post<string[]>(`Download/PesquisaArquivo`, input);
  // }
  
  pesquisarArquivos(input: { ipServidor: string, diretorio: string }): Observable<{ nome: string, dataCriacao: string }[]> {
    return this.http.post<{ nome: string, dataCriacao: string }[]>(`Download/PesquisaArquivo`, input);
  }

  public downloadArquivo(input: { ipServidor: string; diretorio: string; nomeArquivo: string }): Observable<any> {
    return this.http.post<any>(`Download/DownloadArquivo`, input); // JSON com base64
  }
}

